import { colors } from "@/constants";
import React from "react";

const PenIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => {
    return (
        <div className="h-[54px] flex items-center">
            <svg preserveAspectRatio="xMidYMid meet"
                data-bbox="25.783 11.712 137 160"
                viewBox="25.783 11.712 137 160"
                height="38" width="45"
                xmlns="http://www.w3.org/2000/svg"
                data-type="color" role="img"
                aria-label="Pen vector art"
            >
                <g>
                    <path d="M156.775 29.949l-18.59-14.806c-6.844-5.451-16.77-4.281-22.174 2.614L25.783 131.512l4.798 40.2 39.795-4.802 89.009-114.607c5.405-6.895 4.236-16.904-2.61-22.354zM39.224 160.475l-2.809-24.062 26.756 21.239-23.947 2.823zm30.763-13.734L45.4 127.223l82.297-105.667 25.336 20.166-83.046 105.019z"
                        fill={colors.primary}
                    ></path>
                </g>
            </svg>
        </div>
    );
};

export default PenIcon;
